import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { MutationService } from '@app/core/graphql/mutation/mutation.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons';
import { AlertController } from '@ionic/angular';

@Component({
    selector: 'app-application-chain-firstday-checklist',
    templateUrl: './application-chain-firstday-checklist.component.html',
    styleUrls: ['./application-chain-firstday-checklist.component.scss'],
})
export class ApplicationChainFirstdayChecklistComponent implements OnChanges {
    @Input() selectedApplication: any;

    faCheckSquare = faCheckSquare;

    orientations: any;

    preDepartureSelection: string;

    existingPreDepartureOrientation: any = {};

    showPreDepartureRegistration: any = {};

    orientationAlertOptions: any = {
        header: 'Select Orientation Date',
        subHeader: 'Select a date and time.',
        okText: 'Register',
    };

    constructor(public toolService: ToolService, private mutationService: MutationService, private alertController: AlertController) {}

    ngOnChanges() {
        if (this.selectedApplication) {
            this.existingPreDepartureOrientation = this.selectedApplication.predepartureorientation;
            this.identifyRegistrationOptions(this.selectedApplication.id);
            this.getApplicationOrientationSchedule(this.selectedApplication.id);
        }
    }

    preDepartureChange() {
        this.existingPreDepartureOrientation = null;
    }

    preDepartureConferenceSelected(ev: any) {
        this.mutationService
            .preDepartureRegistration({
                predepartureselection: ev.detail.value,
                id: this.selectedApplication.id,
            })
            .subscribe((response) => {
                this.existingPreDepartureOrientation = ev.detail.value;
            });
        this.registrationSuccess('');
    }

    identifyRegistrationOptions(id: string) {
        this.mutationService.identifyRegistrationOptions({ id: id }).subscribe((response) => {
            this.showPreDepartureRegistration = response.data.identifyRegistrationOptions.showPreDepartureRegistration;
        });
    }

    getApplicationOrientationSchedule(id: string) {
        this.mutationService.getOrientationSchedule({ id: id }).subscribe((response) => {
            this.orientations = response.data.getOrientationSchedule;
        });
    }

    async registrationSuccess(type) {
        const alert = await this.alertController.create({
            header: 'Registration Complete',
            message: 'Thank you for registering for your ' + type + ' orientation.',
            buttons: [
                {
                    text: 'Okay',
                    handler: () => {
                        // console.log('Confirm Okay');
                    },
                },
            ],
        });

        await alert.present();
    }
}
